import { Property, AuditStdEdit , Info} from './auditstd-edit-model'
import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime'
import { TimeSpan } from 'typescript-dotnet-es6/System/Time/TimeSpan'
import { format } from 'typescript-dotnet-es6/System/Text/Utility'
import { CorporateDateRules } from '../utilities/corporateDateRules'
import {AddDaysToDate} from '../../../../core'
import { SearchBarComponent } from '@progress/kendo-angular-dropdowns'

    export class ImportValidator {
      applyDateRulesOnPropertyValidate = true; //legacy
      constructor() {
      }
      now:()=>DateTime = ()=>{return DateTime.now};

      public ValidateSeason(property: Property, season: number, startDate: DateTime, endDate: DateTime, previousSeasonEndDate: Date, originalStart: DateTime): boolean {
          if (startDate !== undefined && endDate !== undefined) {
              if (startDate == null && endDate == null) {
                  return false;
              }
              if (startDate == null && endDate != null) {
                  property.Errors.push( { Message: format("Season {0} Missing Start Date", season) });
                  return false;
              }
              if (startDate != null && endDate == null) {
                  property.Errors.push( { Message: format("Season {0} Missing End Date", season) });
                  return false;
              }
              if (endDate.toJsDate() < this.now().date.toJsDate()) {
                  property.Warnings.push( { Message: format("Season {0} Is In The Past", season) });
                  property.SetSeasonStartDate(season, originalStart)
                  return false;
              }
              if (endDate.toJsDate() < startDate.toJsDate()) {
                  property.Warnings.push( { Message: format("Season {0} End Date Is Prior To Season {0} Start Date", season) });
                  return false;
              }
          }
          else {
              property.Errors.push( { Message: format("Season {0} dates were received in an invalid format and could not be converted for import.", season) });
              return false;
          }
          var seasonStartDateLengthFromNow = startDate.timePassedSince(  this.now());
          var seasonEndDateLengthFromNow = endDate.timePassedSince(  this.now());
          if (seasonStartDateLengthFromNow.days > 330) {
              property.SetSeasonStartDate(season, originalStart);
              property.Warnings.push( { Message: format("Season {0} start date is greater than 330 days in the future.  No valid season can be generated.", season) });
              return false;
          }
          if (seasonEndDateLengthFromNow.days > 330) {
              var newEndSeason: DateTime = AddDaysToDate(this.now(), 330);
              property.SetSeasonEndDate(season, newEndSeason);
              property.Information.push( {
                  Message: format("Season {1} end date is greater than 330 days in the future. Season {1} End Date was reset to {0}",
                      newEndSeason.toJsDate().toLocaleDateString(), season)
              });
          }
          if (startDate.toJsDate() < this.now().date.toJsDate()) {
              let newstartDate = AddDaysToDate(this.now(), 1);
              property.Information.push( {
                  Message: format("Season {2} start date {0} is prior to the audit run Date.  Date reset to {1}",
                      startDate.toJsDate().toLocaleDateString(), newstartDate.toJsDate().toLocaleDateString(), season)
              });
              startDate = newstartDate; //now way to update as a reference
              property.SetSeasonStartDate(season, newstartDate);
          }
          if (previousSeasonEndDate != null) {
            let earliestStartDate = new DateTime(previousSeasonEndDate);
            earliestStartDate = AddDaysToDate( earliestStartDate,1);
            if (endDate.toJsDate() < earliestStartDate.toJsDate()) {
                property.Information.push( {
                    Message: format("Season {3} {0} - {1} overlaps previous seasons end date {2}. Season ignored.",
                        startDate.toJsDate().toLocaleDateString(), endDate.toJsDate().toLocaleDateString(), previousSeasonEndDate.toLocaleDateString(), season)
                });
                property.SetSeasonStartDate(season, null);
                property.SetSeasonEndDate(season, null);
                return false;
            }
            else if (startDate.toJsDate() <= previousSeasonEndDate) {
                property.Information.push( {
                    Message: format("Season {2} start date {0} overlaps previous season end date {1}.  Start date reset to {3}",
                        startDate.toJsDate().toLocaleDateString(), previousSeasonEndDate.toLocaleDateString(), season, earliestStartDate.toJsDate().toLocaleDateString())
                });
                property.SetSeasonStartDate(season, earliestStartDate);
            }
          }
          var tmp: DateTime = property.GetSeasonEndDate(season);
          if (tmp != null)
              previousSeasonEndDate.setTime(tmp.toJsDate().valueOf()); //update as reference
          return true;
      }
      public GetValidSeasonCount(property: Property): number {
          var validSeasons = 0;
          if (property.Season1Valid)
              validSeasons++;
          if (property.Season2Valid)
              validSeasons++;
          if (property.Season3Valid)
              validSeasons++;
          if (property.Season4Valid)
              validSeasons++;
          if (property.Season5Valid)
              validSeasons++;
          if (property.Season6Valid)
              validSeasons++;
          if (property.Season7Valid)
              validSeasons++;
          if (property.Season8Valid)
              validSeasons++;
          return validSeasons;
      }
      public Validate(dateSelectionRule: CorporateDateRules.DateSelectionRule, property: Property, quickAudit:boolean): boolean {
        try {
          if (!property.LoadedFromOriginal) {
              property.Season1Valid = true;
              property.Season2Valid = true;
              property.Season3Valid = true;
              property.Season4Valid = true;
              property.Season5Valid = true;
              property.Season6Valid = true;
              property.Season7Valid = true;
              property.Season8Valid = true;
              this.ValidateGDSCodes(property, quickAudit);
              this.ValidateNoneRequiredFields(property);
              this.ValidateAmenities(property);
              this.ValidatePolicies(property);
              property.truncateOversizedStrings();
              var validSeasons = 0;
              property.Season1Valid = true;
              property.Season2Valid = true;
              property.Season3Valid = true;
              property.Season4Valid = true;
              property.Season5Valid = true;
              property.Season6Valid = true;
              property.Season7Valid = true;
              property.Season8Valid = true;
              var passLastValidEndDate: Date = new Date(0);
              property.Season1Valid = this.ValidateSeason(property, 1, property.Season1StartDate, property.Season1EndDate, passLastValidEndDate, property.Season1RestoreStartDate);
              property.Season2Valid = this.ValidateSeason(property, 2, property.Season2StartDate, property.Season2EndDate, passLastValidEndDate, property.Season2RestoreStartDate);
              property.Season3Valid = this.ValidateSeason(property, 3, property.Season3StartDate, property.Season3EndDate, passLastValidEndDate, property.Season3RestoreStartDate);
              property.Season4Valid = this.ValidateSeason(property, 4, property.Season4StartDate, property.Season4EndDate, passLastValidEndDate, property.Season4RestoreStartDate);
              property.Season5Valid = this.ValidateSeason(property, 5, property.Season5StartDate, property.Season5EndDate, passLastValidEndDate, property.Season5RestoreStartDate);
              property.Season6Valid = this.ValidateSeason(property, 6, property.Season6StartDate, property.Season6EndDate, passLastValidEndDate, property.Season6RestoreStartDate);
              property.Season7Valid = this.ValidateSeason(property, 7, property.Season7StartDate, property.Season7EndDate, passLastValidEndDate, property.Season7RestoreStartDate);
              property.Season8Valid = this.ValidateSeason(property, 8, property.Season8StartDate, property.Season8EndDate, passLastValidEndDate, property.Season8RestoreStartDate);
              validSeasons = this.GetValidSeasonCount(property);
              PackSeasons(property, true);
              if (this.applyDateRulesOnPropertyValidate && validSeasons == 1) {
                if (property.AutoExtractSeasons) {
                    try {
                        CorporateDateRules.ExtractSeasons(property, dateSelectionRule, true);
                    }
                    catch (ex) {
                        property.Errors.push( { Message: "Unexpected exception building seasons; " + ex.Message });
                        return false;
                    }
                }
              }
              CorporateDateRules.ExtractCheckDates(property, dateSelectionRule, true);
              PackSeasons(property, false);
              if (property.Season1Valid && property.Season1StartDate != null && !CorporateDateRules.DoesSeasonContainCheckableDates(1, property, dateSelectionRule)) {
                  property.Information.push( {
                      Message: format("Season 1 {0}-{1} resulted in no dates to be checked.",
                          property.Season1StartDate.toJsDate().toLocaleDateString(), property.Season1EndDate.toJsDate().toLocaleDateString())
                  });
                  property.Season1Valid = false;
              }
              if (property.Season2Valid && property.Season2StartDate != null && !CorporateDateRules.DoesSeasonContainCheckableDates(2, property, dateSelectionRule)) {
                  property.Information.push( {
                      Message: format("Season 2 {0}-{1} resulted in no dates to be checked.",
                          property.Season2StartDate.toJsDate().toLocaleDateString(), property.Season2EndDate.toJsDate().toLocaleDateString())
                  });
                  property.Season2Valid = false;
              }
              if (property.Season3Valid && property.Season3StartDate != null && !CorporateDateRules.DoesSeasonContainCheckableDates(3, property, dateSelectionRule)) {
                  property.Information.push( {
                      Message: format("Season 3 {0}-{1} resulted in no dates to be checked.",
                          property.Season3StartDate.toJsDate().toLocaleDateString(), property.Season3EndDate.toJsDate().toLocaleDateString())
                  });
                  property.Season3Valid = false;
              }
              if (property.Season4Valid && property.Season4StartDate != null && !CorporateDateRules.DoesSeasonContainCheckableDates(4, property, dateSelectionRule)) {
                  property.Information.push( {
                      Message: format("Season 4 {0}-{1} resulted in no dates to be checked.",
                          property.Season4StartDate.toJsDate().toLocaleDateString(), property.Season4EndDate.toJsDate().toLocaleDateString())
                  });
                  property.Season4Valid = false;
              }
              if (property.Season5Valid && property.Season5StartDate != null && !CorporateDateRules.DoesSeasonContainCheckableDates(5, property, dateSelectionRule)) {
                  property.Information.push( {
                      Message: format("Season 5 {0}-{1} resulted in no dates to be checked.",
                          property.Season5StartDate.toJsDate().toLocaleDateString(), property.Season5EndDate.toJsDate().toLocaleDateString())
                  });
                  property.Season5Valid = false;
              }
              if (property.Season6Valid && property.Season6StartDate != null && !CorporateDateRules.DoesSeasonContainCheckableDates(6, property, dateSelectionRule)) {
                  property.Information.push( {
                      Message: format("Season 6 {0}-{1} resulted in no dates to be checked.",
                          property.Season4StartDate.toJsDate().toLocaleDateString(), property.Season6EndDate.toJsDate().toLocaleDateString())
                  });
                  property.Season6Valid = false;
              }
              if (property.Season7Valid && property.Season7StartDate != null && !CorporateDateRules.DoesSeasonContainCheckableDates(7, property, dateSelectionRule)) {
                  property.Information.push( {
                      Message: format("Season 7 {0}-{1} resulted in no dates to be checked.",
                          property.Season7StartDate.toJsDate().toLocaleDateString(), property.Season7EndDate.toJsDate().toLocaleDateString())
                  });
                  property.Season7Valid = false;
              }
              if (property.Season8Valid && property.Season8StartDate != null && !CorporateDateRules.DoesSeasonContainCheckableDates(8, property, dateSelectionRule)) {
                  property.Information.push( {
                      Message: format("Season 8 {0}-{1} resulted in no dates to be checked.",
                          property.Season8StartDate.toJsDate().toLocaleDateString(), property.Season8EndDate.toJsDate().toLocaleDateString())
                  });
                  property.Season8Valid = false;
              }
          }

          this.ValidateExpectedRate(1, property, property.Season1Valid, property.Season1ExpectedPrice, property.Season1Dynamic, property.Season1Ceiling)
          this.ValidateExpectedRate(2, property, property.Season2Valid, property.Season2ExpectedPrice, property.Season2Dynamic, property.Season2Ceiling)
          this.ValidateExpectedRate(3, property, property.Season3Valid, property.Season3ExpectedPrice, property.Season3Dynamic, property.Season3Ceiling)
          this.ValidateExpectedRate(4, property, property.Season4Valid, property.Season4ExpectedPrice, property.Season4Dynamic, property.Season4Ceiling)
          this.ValidateExpectedRate(5, property, property.Season5Valid, property.Season5ExpectedPrice, property.Season5Dynamic, property.Season5Ceiling)
          this.ValidateExpectedRate(6, property, property.Season6Valid, property.Season6ExpectedPrice, property.Season6Dynamic, property.Season6Ceiling)
          this.ValidateExpectedRate(7, property, property.Season7Valid, property.Season7ExpectedPrice, property.Season7Dynamic, property.Season7Ceiling)
          this.ValidateExpectedRate(8, property, property.Season8Valid, property.Season8ExpectedPrice, property.Season8Dynamic, property.Season8Ceiling)
        } catch (error) {
          console.log(error);
          return false;
        }
          return true;
      }

      public ValidateExpectedRate(season: number, property: Property, seasonValid:boolean, expectedPrice: number, dynamicRate:boolean, ceiling?: number){
        if (expectedPrice == -1 && seasonValid) {
          property.Errors.push( { Message: "Cannot find a valid value for Season " + season + " Price." });
        }
      }

      public ValidatePolicies(property: Property){
          if(property.BidPolicyCancellation && property.BidPolicyCancellation != null && property.BidPolicyCancellation.length > 15) {
              property.Errors.push({Message: "Cancellation Policy has more than 15 characters"});
          }
          return true;
      }

      public ValidateAmenities(property: Property){
        if(property.BidAmenityBreakfast != null && property.BidAmenityBreakfast != 'Y' && property.BidAmenityBreakfast != 'N' && property.BidAmenityBreakfast != "" ){
            property.Errors.push({Message: "Incorrect value for the amenity Breakfast"});
        }
        if(property.BidAmenityInternet != null && property.BidAmenityInternet != 'Y' && property.BidAmenityInternet != 'N' && property.BidAmenityInternet != "" ){
            property.Errors.push({Message: "Incorrect value for the amenity Internet"});
        }
        if(property.BidAmenityParking != null && property.BidAmenityParking != 'Y' && property.BidAmenityParking != 'N' && property.BidAmenityParking != "" ){
            property.Errors.push({Message: "Incorrect value for the amenity Parking"});
        }
        if(property.BidAmenityAirport != null && property.BidAmenityAirport != 'Y' && property.BidAmenityAirport != 'N' && property.BidAmenityAirport !="" ){
            property.Errors.push({Message: "Incorrect value for the amenity TransportionToAirport"});
        }
        if(property.BidAmenityLocalShuttle != null && property.BidAmenityLocalShuttle != 'Y' && property.BidAmenityLocalShuttle != 'N' && property.BidAmenityLocalShuttle != ""){
            property.Errors.push({Message: "Incorrect value for the amenity LocalOfficeTransportation"});
        }
        return true;
      }

      public ValidateGDSCodes(property: Property, quickAudit:boolean): boolean {
          var AmadeusChainCode: string = property.AmadeusChainCode.trim().toUpperCase();
          var AmadeusPropCode: string = property.AmadeusPropCode.trim().toUpperCase();
          var AmadeusRateAccessCode: string = property.AmadeusRateAccessCode.trim().toUpperCase();
          var ApolloChainCode: string = property.ApolloChainCode.trim().toUpperCase();
          var ApolloPropCode: string = property.ApolloPropCode.trim().toUpperCase();
          var ApolloRateAccessCode: string = property.ApolloRateAccessCode.trim().toUpperCase();
          var GalileoChainCode: string = property.GalileoChainCode.trim().toUpperCase();
          var GalileoPropCode: string = property.GalileoPropCode.trim().toUpperCase();
          var GalileoRateAccessCode: string = property.GalileoRateAccessCode.trim().toUpperCase();
          var SabreChainCode: string = property.SabreChainCode.trim().toUpperCase();
          var SabrePropCode: string = property.SabrePropCode.trim().toUpperCase();
          var SabreRateAccessCode: string = property.SabreRateAccessCode.trim().toUpperCase();
          var WorldspanChainCode: string = property.WorldspanChainCode.trim().toUpperCase();
          var WorldspanPropCode: string = property.WorldspanPropCode.trim().toUpperCase();
          var WorldspanRateAccessCode: string = property.WorldspanRateAccessCode.trim().toUpperCase();
          if (AmadeusChainCode == "XX" || AmadeusChainCode == "YY" || AmadeusChainCode == "ZZ" || AmadeusChainCode == "NA") {
              property.ProcessAmadeus = false;
              property.AmadeusChainCode = "";
              property.AmadeusPropCode = "";
              property.AmadeusRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Amadeus Not Processed Because Chain Code Contained XX/YY/ZZ/NA" });
          }
          else if (AmadeusPropCode == "XX" || AmadeusPropCode == "YY" || AmadeusPropCode == "ZZ" || AmadeusPropCode == "NA") {
              property.ProcessAmadeus = false;
              property.AmadeusChainCode = "";
              property.AmadeusPropCode = "";
              property.AmadeusRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Amadeus Not Processed Because Property Code Contained XX/YY/ZZ/NA" });
          }
          else if (AmadeusRateAccessCode == "XX" || AmadeusRateAccessCode == "YY" || AmadeusRateAccessCode == "ZZ" || AmadeusRateAccessCode == "NA") {
              property.ProcessAmadeus = false;
              property.AmadeusChainCode = "";
              property.AmadeusPropCode = "";
              property.AmadeusRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Amadeus Not Processed Because Rate Access Code Contained XX/YY/ZZ/NA" });
          }
          if (ApolloChainCode == "XX" || ApolloChainCode == "YY" || ApolloChainCode == "ZZ" || ApolloChainCode == "NA") {
              property.ProcessApollo = false;
              property.ApolloChainCode = "";
              property.ApolloPropCode = "";
              property.ApolloRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Apollo Not Processed Because Chain Code Contained XX/YY/ZZ/NA" });
          }
          else if (ApolloPropCode == "XX" || ApolloPropCode == "YY" || ApolloPropCode == "ZZ" || ApolloPropCode == "NA") {
              property.ProcessApollo = false;
              property.ApolloChainCode = "";
              property.ApolloPropCode = "";
              property.ApolloRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Apollo Not Processed Because Property Code Contained XX/YY/ZZ/NA" });
          }
          else if (ApolloRateAccessCode == "XX" || ApolloRateAccessCode == "YY" || ApolloRateAccessCode == "ZZ" || ApolloRateAccessCode == "NA") {
              property.ProcessApollo = false;
              property.ApolloChainCode = "";
              property.ApolloPropCode = "";
              property.ApolloRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Apollo Not Processed Because Rate Access Code Contained XX/YY/ZZ/NA" });
          }
          if (GalileoChainCode == "XX" || GalileoChainCode == "YY" || GalileoChainCode == "ZZ" || GalileoChainCode == "NA") {
              property.ProcessGalileo = false;
              property.GalileoChainCode = "";
              property.GalileoPropCode = "";
              property.GalileoRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Galileo Not Processed Because Chain Code Contained XX/YY/ZZ/NA" });
          }
          else if (GalileoPropCode == "XX" || GalileoPropCode == "YY" || GalileoPropCode == "ZZ" || GalileoPropCode == "NA") {
              property.ProcessGalileo = false;
              property.GalileoChainCode = "";
              property.GalileoPropCode = "";
              property.GalileoRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Galileo Not Processed Because Property Code Contained XX/YY/ZZ/NA" });
          }
          else if (GalileoRateAccessCode == "XX" || GalileoRateAccessCode == "YY" || GalileoRateAccessCode == "ZZ" || GalileoRateAccessCode == "NA") {
              property.ProcessGalileo = false;
              property.GalileoChainCode = "";
              property.GalileoPropCode = "";
              property.GalileoRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Galileo Not Processed Because Rate Access Code Contained XX/YY/ZZ/NA" });
          }
          if (SabreChainCode == "XX" || SabreChainCode == "YY" || SabreChainCode == "ZZ" || SabreChainCode == "NA") {
              property.ProcessSabre = false;
              property.SabreChainCode = "";
              property.SabrePropCode = "";
              property.SabreRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Sabre Not Processed Because Chain Code Contained XX/YY/ZZ/NA" });
          }
          else if (SabrePropCode == "XX" || SabrePropCode == "YY" || SabrePropCode == "ZZ" || SabrePropCode == "NA") {
              property.ProcessSabre = false;
              property.SabreChainCode = "";
              property.SabrePropCode = "";
              property.SabreRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Sabre Not Processed Because Property Code Contained XX/YY/ZZ/NA" });
          }
          else if (SabreRateAccessCode == "XX" || SabreRateAccessCode == "YY" || SabreRateAccessCode == "ZZ" || SabreRateAccessCode == "NA") {
              property.ProcessSabre = false;
              property.SabreChainCode = "";
              property.SabrePropCode = "";
              property.SabreRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Sabre Not Processed Because Rate Access Code Contained XX/YY/ZZ/NA" });
          }
          if (WorldspanChainCode == "XX" || WorldspanChainCode == "YY" || WorldspanChainCode == "ZZ" || WorldspanChainCode == "NA") {
              property.ProcessWorldspan = false;
              property.WorldspanChainCode = "";
              property.WorldspanPropCode = "";
              property.WorldspanRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Worldspan Not Processed Because Chain Code Contained XX/YY/ZZ/NA" });
          }
          else if (WorldspanPropCode == "XX" || WorldspanPropCode == "YY" || WorldspanPropCode == "ZZ" || WorldspanPropCode == "NA") {
              property.ProcessWorldspan = false;
              property.WorldspanChainCode = "";
              property.WorldspanPropCode = "";
              property.WorldspanRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Worldspan Not Processed Because Property Code Contained XX/YY/ZZ/NA" });
          }
          else if (WorldspanRateAccessCode == "XX" || WorldspanRateAccessCode == "YY" || WorldspanRateAccessCode == "ZZ" || WorldspanRateAccessCode == "NA") {
              property.ProcessWorldspan = false;
              property.WorldspanChainCode = "";
              property.WorldspanPropCode = "";
              property.WorldspanRateAccessCode = "";
              property.Information.push( { DateStamp: this.now(), Message: "Worldspan Not Processed Because Rate Access Code Contained XX/YY/ZZ/NA" });
          }
          if (property.ProcessAmadeus) {
              if (this.isNullOrEmpty(AmadeusChainCode)) {
                  property.Errors.push( { Message: "Amadeus Has A Missing Chain Code" });
              }
              if (this.isNullOrEmpty(AmadeusPropCode)) {
                  property.Errors.push( { Message: "Amadeus Has A Missing Property Code" });
              }
              if (!quickAudit && this.isNullOrEmpty(AmadeusRateAccessCode)) {
                  property.Errors.push( { Message: "Amadeus Has A Missing Rate Access Code" });
              }
          }
          if (property.ProcessApollo) {
              if (this.isNullOrEmpty(ApolloChainCode)) {
                  property.Errors.push( { Message: "Apollo Has A Missing Chain Code" });
              }
              if (this.isNullOrEmpty(ApolloPropCode)) {
                  property.Errors.push( { Message: "Apollo Has A Missing Property Code" });
              }
              if (!quickAudit && this.isNullOrEmpty(ApolloRateAccessCode)) {
                  property.Errors.push( { Message: "Apollo Has A Missing Rate Access Code" });
              }
          }
          if (property.ProcessGalileo) {
              if (this.isNullOrEmpty(GalileoChainCode)) {
                  property.Errors.push( { Message: "Galileo Has A Missing Chain Code" });
              }
              if (this.isNullOrEmpty(GalileoPropCode)) {
                  property.Errors.push( { Message: "Galileo Has A Missing Property Code" });
              }
              if (!quickAudit && this.isNullOrEmpty(GalileoRateAccessCode)) {
                  property.Errors.push( { Message: "Galileo Has A Missing Rate Access Code" });
              }
          }
          if (property.ProcessSabre) {
              if (this.isNullOrEmpty(SabreChainCode)) {
                  property.Errors.push( { Message: "Sabre Has A Missing Chain Code" });
              }
              if (this.isNullOrEmpty(SabrePropCode)) {
                  property.Errors.push( { Message: "Sabre Has A Missing Property Code" });
              }
              if (!quickAudit && this.isNullOrEmpty(SabreRateAccessCode)) {
                  property.Errors.push( { Message: "Sabre Has A Missing Rate Access Code" });
              }
          }
          if (property.ProcessWorldspan) {
              if (this.isNullOrEmpty(WorldspanChainCode)) {
                  property.Errors.push( { Message: "Worldspan Has A Missing Chain Code" });
              }
              if (this.isNullOrEmpty(WorldspanPropCode)) {
                  property.Errors.push( { Message: "Worldspan Has A Missing Property Code" });
              }
              if (!quickAudit && this.isNullOrEmpty(WorldspanRateAccessCode)) {
                  property.Errors.push( { Message: "Worldspan Has A Missing Rate Access Code" });
              }
          }
          return true;
      }
      public ValidateNoneRequiredFields(property: Property): boolean {
          if (this.isNullOrEmpty(property.PropertyName.trim())) {
              property.Warnings.push( { Message: "Property Name Missing.  This Can Result In Blank Fields In Notifications." });
          }
          if (this.isNullOrEmpty(property.ContactName.trim())) {
              property.Warnings.push( { Message: "Contact Name Missing.  This Can Result In Blank Fields In Notifications." });
          }
          if (this.isNullOrEmpty(property.ContactEMail.trim())) {
              property.Warnings.push( { Message: "Contact E-Mail Missing.  This Will Result In No E-Mail Notificatoin Being Sent To This Property." });
          }
          return true;
      }
      isNullOrEmpty(str:string){true
        return str?false:true;
      }
      public ValidateFieldSizes(property: Property): boolean {
          property.PropertyName = this.CheckFieldSize(255, property.PropertyName, "Property Name", property);
          property.PropertyAddress = this.CheckFieldSize(255, property.PropertyAddress, "Property Address", property);
          property.PropertyCity = this.CheckFieldSize(25, property.PropertyCity, "Property City", property);
          property.PropertyStateProvince = this.CheckFieldSize(25, property.PropertyStateProvince, "Property State Province", property);
          property.PropertyPostalCode = this.CheckFieldSize(20, property.PropertyPostalCode, "Postal Code", property);
          property.PropertyCountry = this.CheckFieldSize(20, property.PropertyCountry, "Country Code", property);
          property.ContactName = this.CheckFieldSize(256, property.ContactName, "Contact Name", property);
          property.ContactEMail = this.CheckFieldSize(256, property.ContactEMail, "Contact EMail", property);
          property.RateCurrency = this.CheckFieldSize(3, property.RateCurrency, "Currency Code", property);
          property.AmadeusChainCode = this.CheckFieldSize(10, property.AmadeusChainCode, "Amadeus Chain Code", property);
          property.AmadeusPropCode = this.CheckFieldSize(10, property.AmadeusPropCode, "Amadeus Property Code", property);
          property.AmadeusRateAccessCode = this.CheckFieldSize(10, property.AmadeusRateAccessCode, "Amadeus Rate Access Code", property);
          property.ApolloChainCode = this.CheckFieldSize(10, property.ApolloChainCode, "Apollo Chain Code", property);
          property.ApolloPropCode = this.CheckFieldSize(10, property.ApolloPropCode, "Apollo Property Code", property);
          property.ApolloRateAccessCode = this.CheckFieldSize(10, property.ApolloRateAccessCode, "Apollo Rate Access Code", property);
          property.GalileoChainCode = this.CheckFieldSize(10, property.GalileoChainCode, "Galileo Chain Code", property);
          property.GalileoPropCode = this.CheckFieldSize(10, property.GalileoPropCode, "Galileo Property Code", property);
          property.GalileoRateAccessCode = this.CheckFieldSize(10, property.GalileoRateAccessCode, "Galileo Rate Access Code", property);
          property.SabreChainCode = this.CheckFieldSize(10, property.SabreChainCode, "Sabre Chain Code", property);
          property.SabrePropCode = this.CheckFieldSize(10, property.SabrePropCode, "Sabre Property Code", property);
          property.SabreRateAccessCode = this.CheckFieldSize(10, property.SabreRateAccessCode, "Sabre Rate Access Code", property);
          property.WorldspanChainCode = this.CheckFieldSize(10, property.WorldspanChainCode, "Worldspan Chain Code", property);
          property.WorldspanPropCode = this.CheckFieldSize(10, property.WorldspanPropCode, "Worldspan Property Code", property);
          property.WorldspanRateAccessCode = this.CheckFieldSize(10, property.WorldspanRateAccessCode, "Worldspan Rate Access Code", property);
          return true;
      }
      public CheckFieldSize(maxSize: number, objToCheck: string, WarningTitle: string, property: Property): string {
        if (objToCheck) {
          if (objToCheck.length > maxSize) {
            property.Information.push( { Message: format("{0} was {1} characters and was truncated to the maximum size of {2}", WarningTitle, objToCheck.length, maxSize) });
            return objToCheck.substring(0, maxSize );
          }
        }
        return objToCheck;
      }
  }
function PackSeasons(property: Property, preExtractCheckDates:boolean) {
  var unFilledSeason: number = 0
  for (var i: number = 1; i <= 8; i++) {
    if (property.IsSeasonValid(i)) {
      if (unFilledSeason != 0) {
        property.MoveSeason(unFilledSeason, i)
        if(preExtractCheckDates){
          property.Information.push({
            Message: format("Move Season {0} down to Season {1}. " ,
              i, unFilledSeason)
          });

        }
        else{
          property.Warnings.push({
            Message: format("Moving Season {0} down to Season {1} as a result of applying Day Generation Rules",
              i, unFilledSeason)
          });

        }
        unFilledSeason++
      }
    }
    else {
      if (unFilledSeason == 0) {
        unFilledSeason = i
      } else {
        property.SetSeasonValid(i, false)
        property.SetSeasonStartDate(i, null)
        property.SetSeasonEndDate(i, null)
        property.SetSeasonPrice(i, 0.0, false, null)
      }
    }

  }
  let season = property.GetSeason(1);
  if ((season.StartDate==null || season.EndDate==null || season.ExpectedPrice == null)
      && preExtractCheckDates==false) {
    property.Errors.push( { Message: "Could not find a season start and end date or price for this property"});
  }

}

